import { Collapse, Divider } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
} from "../../components/styled/common";
import { BannerMobileItems } from "./constants";
import CollapseExpandIcon from "../../components/CollapseExpandIcon";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useBannerMobileContext } from "../../context/BannerMobileContext/BannerMobileContext";
import { useEffect } from "react";

const AddBannerMobile = () => {
	const { addBannerMobile, clearBannerMobileFormData, setBannerMobileForm, operationStatus } = useBannerMobileContext();

	useEffect(() => {
		setBannerMobileForm((prevForm) => ({ ...prevForm, isActive: false, bannerTypeEnum: 7, isUpper: true }));

		return () => {
			clearBannerMobileFormData();
		};
	}, []);

	return (
		<ActionContainer>
			<ActionItemsContainer>
				<h3>Yeni Mobil Banner Ekleme</h3>
				<Divider />
				<Collapse
					items={BannerMobileItems}
					expandIconPosition="end"
					bordered={false}
					ghost
					expandIcon={CollapseExpandIcon}
					defaultActiveKey={["1", "2", "3", "4"]}
				/>
				<SubmitButtonOverlay>
					<MainButtonComponent onClick={addBannerMobile} loading={operationStatus.type === "loading" && operationStatus.operation === "add"}>
						Banner Ekle
					</MainButtonComponent>
				</SubmitButtonOverlay>
			</ActionItemsContainer>
		</ActionContainer>
	);
};

export default AddBannerMobile;
